/*
 * @Description: 自定义下拉框选项是否展示
 * @Author: mdb
 * @Date: 2022-10-26 10:35:45
 * @LastEditTime: 2023-04-21 10:51:45
 * @LastEditors: mdb
 */
import { onBeforeMount } from 'vue'
import { customerTypeEnum, genderEnum, linkRoleTypeEnum } from '@/views/marketing/commonEnum/dataConfig'
import { useEnum } from './useEnum'
import { paramCodesEnum } from '../common'

const { paramCodeData, tagListEnum, getByParamCodes, getTagList } = useEnum()

/**
 * 指定字段才需要展示自定义选择框
 */
const showCustomSelect = (field: string) => {
  const list = [
    'customerType',
    'customerTag',
    'contact.sex',
    'contact.jobRole',
    'business.cargoType',
    'business.salePlatform',
    'business.warehouse',
    'business.monthSales',
    'business.serviceNeeds',
    'business.cooperation',
    'business.salesCategory',
    'business.customerCategory',

    'channel',
    'customerOffice',
    'clientType',
    'business.salesChannel',
    'business.businessTypeSelect',
    'business.shipments',
    'business.regionalWarehouse'
  ]
  return list.includes(field)
}

export function useCustomSelect(subdomain: 'fbu' | 'lbu' | 'ofbu') {
  onBeforeMount(() => {
    getByParamCodes(subdomain)
    getTagList()
  })

  const customSelectOption = (field: string) => {
    let result = []
    switch (field) {
      case 'customerType':
        result = customerTypeEnum.map((e) => ({ name: e.label, id: e.value }))
        break
      case 'customerTag':
        result = tagListEnum.value
        break
      case 'contact.sex':
        result = genderEnum.map((e) => ({ name: e.label, id: e.value }))
        break
      case 'contact.jobRole':
        result = linkRoleTypeEnum.map((e) => ({ name: e.label, id: e.value }))
        break
      case 'business.cargoType':
        result = paramCodeData.value[paramCodesEnum[subdomain].product]
        break
      case 'business.salePlatform':
        result = paramCodeData.value[paramCodesEnum[subdomain].channel]
        break
      case 'business.warehouse':
        result = paramCodeData.value[paramCodesEnum[subdomain].demand]
        break
      case 'business.monthSales':
        result = paramCodeData.value[paramCodesEnum[subdomain].monthly]
        break
      case 'business.serviceNeeds':
        result = paramCodeData.value[paramCodesEnum[subdomain].service]
        break
      case 'business.salesCategory':
        result = paramCodeData.value[paramCodesEnum[subdomain].category]
        break
      case 'business.customerCategory':
        result = paramCodeData.value[paramCodesEnum[subdomain].customerCategory]
        break
      case 'business.shipments':
        result = paramCodeData.value[paramCodesEnum[subdomain].shipments]
        break
      case 'business.businessTypeSelect':
        result = paramCodeData.value[paramCodesEnum[subdomain].businessTypeSelect]
        break
      case 'business.salesChannel':
        result = paramCodeData.value[paramCodesEnum[subdomain].salesChannel]
        break
      case 'clientType':
        result = paramCodeData.value[paramCodesEnum[subdomain].clientType]
        break
      case 'channel':
        result = paramCodeData.value[paramCodesEnum[subdomain].clueChannel]
        break
      case 'business.regionalWarehouse':
        result = paramCodeData.value[paramCodesEnum[subdomain].regionalWarehouse]
        break

      default:
        result = []
        break
    }
    return result
  }

  return { showCustomSelect, customSelectOption, paramCodeData }
}
